import { FormControl, FormHelperText, FormLabel, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import Box from '@mui/material/Box';
import { getIn } from 'formik';
import React from 'react';

interface InputSelectFormikProps {
  formik: any;
  label: string;
  labelTexto: string;
  placeholder?: string;
  width?: string;
  required?: boolean;
  disabled?: boolean;
  margin?: 'none' | 'dense' | 'normal' | null;
  options: ISelectOption[];
}

interface ISelectOption {
  value: string | number;
  label: string;
  disabled?: boolean;
}

const InputSelectFormik: React.FC<InputSelectFormikProps> = ({
  formik,
  label,
  labelTexto,
  placeholder = '',
  required = false,
  disabled = false,
  margin = null,
  options,
}) => {

  // Função para obter o valor formatado para exibição
  const getDisplayValue = () => {
    const currentValue = getIn(formik.values, label);
    const option = options.find(option => option.value === currentValue);
    return option?.value || '';
  };

  // Rótulo que será exibido acima do campo
  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const value = event.target.value;
    formik.setFieldValue(label, value || '');
  };

  const handleGetError = () => {
    const currentValue = getIn(formik.errors, label);
    if (currentValue) {
      return currentValue;
    }
    return null;
  }

  const handleGetTouched = () => {
    return getIn(formik.touched, label);
  }

  return (
    <>




      <FormControl
        fullWidth
        margin={margin || 'normal'}
        required
        error={handleGetTouched() && Boolean(handleGetError())}
      >
        <InputLabel
          id={`${label}-label`}
          shrink={true} // Esta propriedade mantém o label sempre suspenso
        >
          {labelTexto}
        </InputLabel>
        <Select
          id={`${label}-input`}
          labelId={`${label}-label`}
          label={labelTexto}
          variant='outlined'
          placeholder={placeholder}
          required={required}
          value={getDisplayValue()}
          onChange={(event) => handleChange(event)}
          disabled={disabled}
          error={handleGetTouched() && Boolean(handleGetError())}
          notched={true} // Garante que a borda tenha o recorte para o label
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {!!handleGetError() && (
          <FormHelperText error>
            {formik.errors[label]}
          </FormHelperText>
        )}
      </FormControl>

    </>
  );
};

export default InputSelectFormik;
